import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import { createLoanData, getLoanDetails } from "../../../../Utility/Api";
import { WarehouseContext } from "../../../../Utility/UserContext";
import { getFormattedCurrentDate2, NaviGate } from "../../../../Utility/function";

const Loanreport = () => {
    const { showLoader, hideLoader, UserItem, shopItem } = useContext(WarehouseContext);

    const [loans, setLoans] = useState([]);
    const [showAddLoanModal, setShowAddLoanModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedLoan, setSelectedLoan] = useState({});
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("taken");


    const [loanData, setLoanData] = useState({
        type: "0",
        amount: "",
        user_id: UserItem?.user_id || "",
        shop_id: shopItem?.shop_id || "",
        created_by: UserItem?.user_id || "",
        date: "",
        due_date: "",
        remarks: "",
        froms: ""
    });

    const [paymentData, setPaymentData] = useState({
        type: "1",
        amount: "",
        user_id: UserItem?.user_id || "",
        shop_id: shopItem?.shop_id || "",
        created_by: UserItem?.user_id || "",
        due_date: "",
        remarks: "Loan payment",
        froms: "",
        loan_id: ""
    });

    const getMaxPayableAmount = () => {
        return selectedLoan?.remaining ?
            Number(selectedLoan.remaining) : 0;
    };

    useEffect(() => {
        fetchLoans();
    }, [currentPage]);
    useEffect(() => {
        setCurrentPage(1);
    }, [activeTab]);

    const fetchLoans = async () => {
        showLoader();
        try {
            const response = await getLoanDetails({
                shop_id: shopItem?.shop_id || "",
                page: currentPage,
                loan_type: activeTab === "taken" ? "Loan Taken" : "Loan Paid"

            });

            if (response.data && response.data.data) {
                setLoans(response.data.data);
                if (response.data.pagination) {
                    setTotalPages(response.data.pagination.total_pages || 1);
                }
            }
        } catch (error) {
            console.error("Error fetching loans:", error);
            toast.error("Failed to load loans data");
        } finally {
            hideLoader();
        }
    };

    const takenLoans = loans.filter(
        loan => loan.loan_type === "Loan Taken"
    );

    const paidLoans = loans.filter(
        loan => loan.loan_type === "Loan Paid"
    );

    const filteredLoans =
        activeTab === "taken"
            ? loans.filter(l => l.loan_type === "Loan Taken")
            : loans.filter(l => l.loan_type === "Loan Paid");

    const ITEMS_PER_PAGE = 10;

    const paginatedLoans = filteredLoans.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const totalPagess = Math.ceil(filteredLoans.length / ITEMS_PER_PAGE);


    const handleAddLoan = async () => {
        if (!validateLoanForm()) return;

        showLoader();
        try {
            const formattedDueDate = formatDateForAPI(loanData.due_date);
            const payload = {
                ...loanData,
                due_date: formattedDueDate
            };

            const response = await createLoanData(payload);

            if (response.data && response.data.status === "success") {
                toast.success("Loan added successfully");
                setShowAddLoanModal(false);
                resetLoanForm();
                fetchLoans();
            } else {
                toast.error(response.data?.message || "Failed to add loan");
            }
        } catch (error) {
            console.error("Error adding loan:", error);
            toast.error("Error adding loan. Please try again.");
        } finally {
            hideLoader();
        }
    };

    const handleLoanPayment = async () => {
        if (!validatePaymentForm()) return;
        showLoader();
        try {
            const formattedDueDate = formatDateForAPI(paymentData.due_date || getFormattedCurrentDate2());

            const payload = {
                ...paymentData,
                due_date: formattedDueDate,
                loan_id: selectedLoan.loan_id,

            };

            const response = await createLoanData(payload);

            if (response.data && response.data.status === "success") {
                toast.success(
                    `Payment successful! Paid: ${response.data.paid_amount}, Remaining: ${response.data.remaining}`
                  );
                setShowPaymentModal(false);
                resetPaymentForm();
                fetchLoans();
            } else {
                toast.error(response.data?.message || "Failed to record loan payment");
            }
        } catch (error) {
            console.error("Error recording loan payment:", error);
            toast.error("Error recording payment. Please try again.");
        } finally {
            hideLoader();
        }
    };

    const formatDateForAPI = (dateString) => {
        if (!dateString) return getFormattedCurrentDate2();

        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;

        try {
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        } catch (error) {
            console.error("Date formatting error:", error);
            return getFormattedCurrentDate2();
        }
    };

    const validateLoanForm = () => {
        if (!loanData.amount || isNaN(loanData.amount) || parseFloat(loanData.amount) <= 0) {
            toast.error("Please enter a valid loan amount");
            return false;
        }

        if (!loanData.froms) {
            toast.error("Please enter the lender's name");
            return false;
        }

        if (!loanData.due_date) {
            toast.error("Please select a due date");
            return false;
        }

        return true;
    };

    const validatePaymentForm = () => {
        const amount = Number(paymentData.amount || 0);
        const pending = getMaxPayableAmount();

        if (amount <= 0) {
            toast.error("Enter a valid payment amount");
            return false;
        }

        if (amount > pending) {
            toast.error("Payment cannot exceed pending amount");
            return false;
        }

        return true;
    };

    // Reset loan form
    const resetLoanForm = () => {
        setLoanData({
            type: "0",
            amount: "",
            user_id: UserItem?.user_id || "",
            shop_id: shopItem?.shop_id || "",
            created_by: UserItem?.user_id || "",
            due_date: "",
            date: "",
            remarks: "",
            froms: ""
        });
    };

    const resetPaymentForm = () => {
        setPaymentData({
            type: "1",
            amount: "",
            user_id: UserItem?.user_id || "",
            shop_id: shopItem?.shop_id || "",
            created_by: UserItem?.user_id || "",
            due_date: getFormattedCurrentDate2(),
            remarks: "Loan payment",
            froms: "",
            loan_id: ""
        });
    };

    const openPaymentModal = (loan) => {
        setSelectedLoan(loan);
        setPaymentData({
            ...paymentData,
            froms: loan.from,
            loan_id: loan.loan_id
        });
        setShowPaymentModal(true);
    };


    const handleLoanInputChange = (e) => {
        const { name, value } = e.target;

        setLoanData(prev => {
            if (name === "date" && prev.due_date && value > prev.due_date) {
                return {
                    ...prev,
                    date: value,
                    due_date: value
                };
            }

            return {
                ...prev,
                [name]: value
            };
        });
    };


    const handlePaymentInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "amount") {
            let amount = Number(value);
            const maxAmount = getMaxPayableAmount();

            if (amount < 0) amount = 0;

            if (amount > maxAmount) {
                amount = maxAmount;
            }

            setPaymentData({
                ...paymentData,
                [name]: amount
            });
        } else {
            setPaymentData({
                ...paymentData,
                [name]: value
            });
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";

        try {
            const date = new Date(dateString);
            return date.toLocaleDateString();
        } catch (error) {
            return dateString;
        }
    };

    const getLoanStatus = (loan) => {
        const outstanding = Number(loan.remaining || 0);

        if (outstanding <= 0) return "Paid";
        if (new Date(loan.due_date) < new Date()) return "Overdue";
        return "Pending";
    };

    const totalAmount = getMaxPayableAmount();
    const paidAmount = Number(paymentData.amount || 0);

    const remainingAmount = Math.max(
        totalAmount - paidAmount,
        0
    ).toFixed(2);

    return (
        <div className="page-content">
            <NaviGate />

            <div className="mb-0 d-flex justify-content-between align-items-center">
                <h5 className="mb-0 text-uppercase">Loan Management</h5>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setShowAddLoanModal(true)}
                >
                    Add New Loan
                </button>
            </div>
            <hr className="mt-2 mb-4" />


            <div className="nav nav-tabs   d-flex justify-content-end align-content-center">
                <li className="nav-item ">
                    <button
                        className={`nav-link ${activeTab === "taken" ? "active" : ""
                            }`}
                        onClick={() => setActiveTab("taken")}
                    >
                        Loan Taken
                        <span className="badge bg-warning ms-2">
                            {takenLoans.length}
                        </span>
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === "paid" ? "active" : ""
                            }`}
                        onClick={() => setActiveTab("paid")}
                    >
                        Loan Paid
                        <span className="badge bg-success ms-2">
                            {paidLoans.length}
                        </span>
                    </button>
                </li>
            </div>

            {/* TABLE */}
            <div className="card">
                <div className="card-body table-responsive">
                    <table className="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Lender</th>
                                <th>Loan ID</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Remaining</th>
                                <th>Due Date</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {activeTab === "taken" &&
                                (takenLoans.length ? (
                                    takenLoans.map((loan, i) => {
                                        const status = getLoanStatus(loan);
                                        const pending = Number(
                                            loan.remaining || 0
                                        );
                                        return (
                                            <tr key={loan.loan_id}>
                                                <td>{i + 1}</td>
                                                <td>{loan.from}</td>
                                                <td>{loan.loan_id}</td>
                                                <td>{formatDate(loan.date)}</td>
                                                <td>
                                                    ₹
                                                    {Number(
                                                        loan.amount
                                                    ).toFixed(2)}
                                                </td>
                                                <td className="text-danger fw-bold">
                                                    ₹{pending.toFixed(2)}
                                                </td>
                                                <td>
                                                    {formatDate(
                                                        loan.due_date
                                                    )}
                                                </td>
                                                <td>
                                                    <span
                                                        className={`badge bg-${status === "Overdue"
                                                            ? "danger"
                                                            : "info"
                                                            }`}
                                                    >
                                                        {status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-warning"
                                                        onClick={() =>
                                                            openPaymentModal(
                                                                loan
                                                            )
                                                        }
                                                    >
                                                        Pay
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="9"
                                            className="text-center"
                                        >
                                            No active loans
                                        </td>
                                    </tr>
                                ))}

                            {activeTab === "paid" &&
                                (paidLoans.length ? (
                                    paidLoans.map((loan, i) => (
                                        <tr key={loan.loan_id}>
                                            <td>{i + 1}</td>
                                            <td>{loan.from}</td>
                                            <td>{loan.loan_id}</td>
                                            <td>
                                                {formatDate(loan.date)}
                                            </td>
                                            <td>
                                                ₹
                                                {Number(
                                                    loan.amount
                                                ).toFixed(2)}
                                            </td>
                                            <td className="text-success fw-bold">
                                                {Number(
                                                    loan.remaining
                                                ).toFixed(2)}
                                            </td>
                                            <td>
                                                {formatDate(
                                                    loan.due_date
                                                )}
                                            </td>
                                            <td>
                                                <span className="badge bg-success">
                                                    Paid
                                                </span>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-success"
                                                    disabled
                                                >
                                                    Paid
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="9"
                                            className="text-center"
                                        >
                                            No paid loans
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    {activeTab === "taken" && totalPagess > 1 && (
                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-outline-secondary me-2"
                                disabled={currentPage === 1}
                                onClick={() =>
                                    setCurrentPage(p => p - 1)
                                }
                            >
                                Prev
                            </button>
                            <button
                                className="btn btn-outline-secondary"
                                disabled={currentPage === totalPagess}
                                onClick={() =>
                                    setCurrentPage(p => p + 1)
                                }
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            </div>


            {/* Add Loan Modal */}
            {showAddLoanModal && (
                <>
                    <div className="modal-backdrop fade show"></div>

                    <div
                        className="modal fade show"
                        style={{ display: "block" }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-md">
                            <div className="modal-content shadow-lg  ">

                                <div className="modal-header bg-light ">
                                    <h5 className="modal-title fw-semibold">
                                        <i className="bi bi-cash-stack me-2 text-primary"></i>
                                        Add New Loan
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => (setShowAddLoanModal(false), resetLoanForm())}
                                    ></button>
                                </div>

                                {/* Body */}
                                <div className="modal-body px-4 py-3">
                                    <form>
                                        <div className="mb-3">
                                            <label className="form-label fw-medium">
                                                Lender Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="froms"
                                                value={loanData.froms}
                                                onChange={handleLoanInputChange}
                                                placeholder="Who provided the loan?"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label fw-medium">
                                                Loan Amount <span className="text-danger">*</span>
                                            </label>
                                            <div className="input-group">
                                                <span className="input-group-text fw-semibold">₹</span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="amount"
                                                    value={loanData.amount}
                                                    onChange={handleLoanInputChange}
                                                    placeholder="Enter amount"
                                                    min="0"
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fw-medium">Loan Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="date"
                                                    value={loanData.date}
                                                    max={getFormattedCurrentDate2()}
                                                    onChange={handleLoanInputChange}
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label fw-medium">Due Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="due_date"
                                                    value={loanData.due_date}
                                                    min={loanData.date || getFormattedCurrentDate2()}
                                                    onChange={handleLoanInputChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-2">
                                            <label className="form-label fw-medium">
                                                Remarks <span className="text-muted">(optional)</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                name="remarks"
                                                value={loanData.remarks}
                                                onChange={handleLoanInputChange}
                                                placeholder="Additional details about the loan"
                                                rows="3"
                                            ></textarea>
                                        </div>
                                    </form>
                                </div>

                                {/* Footer */}
                                <div className="modal-footer bg-light rounded-bottom-4 px-4">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => (setShowAddLoanModal(false), resetLoanForm())}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary px-4"
                                        onClick={handleAddLoan}
                                    >
                                        Add Loan
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )}


            {/* Payment Modal */}
            {showPaymentModal && selectedLoan && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header border-0 pb-0">
                                <div>
                                    <h5 className="modal-title fw-bold">Make Loan Payment</h5>
                                    <small className="text-muted">Review loan details before payment</small>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowPaymentModal(false);
                                        resetPaymentForm();
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="card shadow-sm mb-3">
                                    <div className="card-body">

                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h6 className="mb-0 text-muted">Loan Details</h6>
                                            <span className="badge bg-primary">Active</span>
                                        </div>

                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="text-muted small">Lender</div>
                                                <div className="fw-semibold">{selectedLoan.from}</div>
                                            </div>

                                            <div className="col-md-6 text-md-end">
                                                <div className="text-muted small">Total Loan</div>
                                                <div className="fw-semibold text-dark">
                                                    ₹{Number(selectedLoan.amount || 0).toFixed(2)}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="text-muted small">Remaining Balance</div>
                                                <div className="fw-bold text-danger">
                                                    ₹{Number(selectedLoan.remaining || 0).toFixed(2)}
                                                </div>
                                            </div>

                                            <div className="col-md-6 text-md-end">
                                                <div className="text-muted small">Due Date</div>
                                                <div className="fw-semibold">
                                                    {formatDate(selectedLoan.due_date)}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>


                                <form>
                                    <div className="mb-3">
                                        <label className="form-label fw-medium">
                                            Payment Amount <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text">₹</span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="amount"
                                                value={paymentData.amount}
                                                onChange={handlePaymentInputChange}
                                                placeholder="Enter payment amount"
                                                min="0"
                                                max={getMaxPayableAmount()}
                                            />
                                        </div>
                                        {/* <div className="form-text mt-1">
                                            <span className="text-muted">Remaining due: </span>
                                            <span
                                                className={
                                                    remainingAmount === "0.00"
                                                        ? "text-success fw-bold"
                                                        : "text-danger fw-bold"
                                                }
                                            >
                                                ₹{remainingAmount}
                                            </span>
                                        </div> */}

                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-medium">
                                            Remark
                                        </label>
                                        <textarea
                                            className="form-control"
                                            name="remarks"
                                            value={paymentData.remarks}
                                            onChange={handlePaymentInputChange}
                                            placeholder="Payment details"
                                            rows="2"
                                        ></textarea>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowPaymentModal(false);
                                        resetPaymentForm();
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleLoanPayment}
                                    disabled={
                                        Number(paymentData.amount) <= 0 ||
                                        Number(paymentData.amount) > getMaxPayableAmount() ||
                                        !paymentData.amount
                                    }
                                >
                                    Payment
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Loanreport;
